// @flow

import * as React from 'react';
import { graphql, useFragment } from 'react-relay';
import { Flex, Box, useSystem } from 'react-system';
import { useTheme } from '../../theme';
import type { DevelopmentOrganisation_organisation$key } from './__generated__/DevelopmentOrganisation_organisation.graphql';

type Props = {|
  label: string,
  organisation: DevelopmentOrganisation_organisation$key,
|};

export const DevelopmentOrganisation = (props: Props): React.Node => {
  const { text, colors } = useTheme();
  const { media } = useSystem();
  const organisation = useFragment(
    graphql`
      fragment DevelopmentOrganisation_organisation on Organisation {
        name
        formattedAddress
        primaryImage {
          url
        }
      }
    `,
    props.organisation,
  );
  return (
    <Flex flexWrap="wrap">
      <Box mr={3}>
        <div
          css={{
            border: 'solid 1px',
            borderRadius: 5,
            borderColor: colors.grey200,
          }}
        >
          {organisation.primaryImage?.url != null ? (
            <img
              src={organisation.primaryImage.url}
              css={media({
                display: 'block',
                objectFit: 'contain',
                width: ['60px', '80px'],
                height: ['60px', '80px'],
                padding: '4px',
              })}
            />
          ) : (
            <Box
              css={media({
                width: ['60px', '80px'],
                height: ['60px', '80px'],
                padding: '4px',
              })}
            />
          )}
        </div>
      </Box>
      <Box flexShrink={1} flexGrow={1} flexBasis={0}>
        <Box css={media([text.body2, text.body1])}>{props.label}</Box>
        <Box css={media([text.subtitle1, text.h6])}>{organisation.name}</Box>
        <Box css={[text.ellipsis, media([text.body2, text.body1])]}>
          {organisation.formattedAddress}
        </Box>
      </Box>
    </Flex>
  );
};
